import { useState } from "react";
import { Button } from "../../components/forms";
import NewOrgDetails from "../../components/home/NewOrgDetails";
import { usePickerhook } from "../../hooks/usePickerhook";
import { UserItem } from "../../components/users/UserItem";
import { useOrganizationHook } from "../../hooks/useOrganizationHook";
import { ComapnyItem } from "../../components/users/CompanyItem";

const CompanyProfile = () => {
  return (
    <div className="w-full  pr-20 self-start   ">
      <NewOrgDetails issetting style=" w-full   m-0 rounded-[20px] " />
    </div>
  );
};

const CompanyListing = () => {
  const rolepicked = usePickerhook();
  const [entered, setentered] = useState("");
  const companies = [1, 2, 3, 4, 5, 6];
  const [showadduser, setshowadduser] = useState(false);
  const {UserOrgs}=useOrganizationHook()

  const onChange = (e: string) => {
    setentered(e);
  };

  return (
    <div className="w-full pr-20  flex  ">
      <div className={` p-6 bg-white    w-full  rounded-[20px]`}>
        <div className="  w-full  flex justify-between items-center  ">
          <p className="text-textbg font-medium text-sm mb-2 text-[16px] bg-white">
            Companies ({companies.length})
          </p>
        </div>

        <hr />

        <div className="grid grid-cols-2 mt-4 gap-6">
          {UserOrgs.map((i:any) => (
            <ComapnyItem item={i} />
          ))}
        </div>
      </div>
    </div>
  );
};

export { CompanyProfile, CompanyListing };
